<template>
    <tr class="kitchen-zone-printers-row">
        <td class="text-right">
            {{ kitchenZone.name }}
        </td>
        <td>
            <template v-for="(value, index) in localValues"
                      :key="index">
                <div class="input-group-flex">
                    <select :id="'select-' + index"
                            v-model="localValues[index]"
                            class="form-control"
                            @change="updateParentArray">
                        <option :value="null">
                            ({{ l('KITCHEN_SETTINGS.DEFAULT_PRINTER') }})
                        </option>
                        <option :value="SKIP_PRINTING">
                            ({{ l('KITCHEN_SETTINGS.SKIP_PRINTING') }})
                        </option>
                        <option v-for="printerName in printerNames"
                                :key="printerName"
                                :value="printerName">
                            {{ printerName }}
                        </option>
                    </select>
                    <button v-if="index > 0"
                            class="btn btn-default"
                            @click="removeValue(index)">
                        <i class="fa-solid fa-minus"></i>
                    </button>
                    <button v-else
                            class="btn btn-default"
                            @click="addValue()">
                        <i class="fa-solid fa-plus"></i>
                    </button>
                </div>
            </template>
        </td>
    </tr>
</template>

<script>
import SKIP_PRINTING from '@/lib/Printing/SkipPrinting';

export default {
    props: {
        kitchenZone: {
            type: Object,
            required: true,
        },

        printerNames: {
            type: Array,
            required: true,
        },

        modelValue: {
            type: Array,
            required: true,
        },
    },

    emits: ['update:modelValue'],

    data() {
        return {
            numRows: 1,

            localValues: [],
        };
    },

    computed: {
        // We can't use the imported const directly so create a computed property instead.
        SKIP_PRINTING() {
            return SKIP_PRINTING;
        },
    },

    watch: {
        modelValue: {
            handler(newVal) {
                this.localValues = [...newVal]; // Sync with parent if the prop value changes.
            },
            immediate: true,
        },
    },

    methods: {
        addValue() {
            this.localValues.push(null);
            this.updateParentArray(); // Emit the updated array
        },

        removeValue(index) {
            this.localValues.splice(index, 1); // Remove the value at the specified index
            this.updateParentArray(); // Emit the updated array
        },

        updateParentArray() {
            this.$emit('update:modelValue', this.localValues); // Emit the updated array to parent
        },
    },
};
</script>

<style lang="less">
@import "../../../../../less/variables.less";

.kitchen-zone-printers-row {
    .input-group-flex {
        &:not(:first-child) {
            margin-top: @half-gutter-width;
        }
    }
}
</style>
